import type { Lang } from './types';
import { DICT } from './dictionary';

/**
 * Basit i18n durumu. Kütüphane yok.
 *
 * Svelte 5 runes: `$state` bir .svelte.ts modülünde tanımlanır; bileşenler
 * `t()` çağırırken `i18n.lang` okunduğu için dil değişimi reaktif olarak
 * yayılır.
 */
export const i18n = $state<{ lang: Lang }>({ lang: 'en' });

const STORAGE_KEY = 'repcheck.lang';

/** Tarayıcı dilini ve kayıtlı tercihi dikkate alarak başlangıç dilini seçer. */
export function initLang(): void {
	let next: Lang = 'en';
	try {
		const saved = localStorage.getItem(STORAGE_KEY);
		if (saved === 'en' || saved === 'tr') {
			next = saved;
		} else if (typeof navigator !== 'undefined' && /^tr\b/i.test(navigator.language)) {
			next = 'tr';
		}
	} catch {
		/* localStorage kapalıysa varsayılan EN */
	}
	setLang(next);
}

export function setLang(lang: Lang): void {
	i18n.lang = lang;
	if (typeof document !== 'undefined') {
		document.documentElement.lang = lang;
		document.documentElement.dir = 'ltr';
	}
	try {
		localStorage.setItem(STORAGE_KEY, lang);
	} catch {
		/* yoksay */
	}
}

export function toggleLang(): void {
	setLang(i18n.lang === 'en' ? 'tr' : 'en');
}

/**
 * Sözlükten çeviri döndürür.
 * `{name}` yer tutucuları params ile değiştirilir.
 */
export function t(key: string, params?: Record<string, string | number>): string {
	const table = DICT[i18n.lang] ?? DICT.en;
	const raw = table[key] ?? DICT.en[key] ?? key;
	if (!params) return raw;
	return raw.replace(/\{(\w+)\}/g, (m, name: string) =>
		params[name] !== undefined ? String(params[name]) : m
	);
}

/** Diziyi (ör. madde listesi) anahtar önekiyle döndürür. */
export function tList(prefix: string): string[] {
	const table = DICT[i18n.lang] ?? DICT.en;
	return Object.keys(table)
		.filter((k) => k.startsWith(prefix + '.'))
		.sort((a, b) => Number(a.slice(prefix.length + 1)) - Number(b.slice(prefix.length + 1)))
		.map((k) => table[k]);
}
